<template>
  <div
    v-show="callStore.isMinimized"
    class="minimized-modal minimized-modal-class"
  >
    <div class="minimized-wrapper">
      <img
        v-if="callStore.callerInfo && callStore.callerInfo.avatar"
        :src="callStore.callerInfo.avatar"
        alt="Avatar"
        class="rounded-circle pulse-avatar-small default-avatar"
        :class="{ 'pulse-avatar-small': !callStore.isEndedCall }"
        width="40"
        height="40"
      />
      <span
        v-else
        class="b-avatar-custom avatar default-avatar"
        :class="{ 'pulse-avatar-small': !callStore.isEndedCall }"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-user"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      </span>
      <h5 v-if="callStore.isEndedCall" class="text">
        {{ $t("alert.ended") }}
      </h5>
      <h5 v-else-if="callStore.timer" class="text timer">
        {{ callStore.timer }}
      </h5>
      <h5 v-else class="text incoming-text">
        {{ $t("alert.incoming") }}
        <div class="dot-flashing" />
      </h5>
      <div class="cursor-pointer" @click="callStore.toggleMinimize">
        <ExpandIcon :width="20" :height="20" />
      </div>
      <div class="cursor-pointer" @click="handleEndCall">
        <CloseIcon :width="20" :height="20" />
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from "@/components/icons/CloseIcon.vue";
import ExpandIcon from "@/components/icons/ExpandIcon.vue";
import useCallStore from "@/store-pinia/useCallStore";

export default {
  components: {
    CloseIcon,
    ExpandIcon,
  },
  data() {
    return {};
  },
  methods: {
    handleEndCall() {
      // If the call ended, just close
      if (this.callStore.isEndedCall) {
        this.callStore.shownIncomingCallModel = false;
        this.callStore.isMinimized = false;
        return;
      }

      // Always show confirmed pop up
      this.$bvModal
        .msgBoxConfirm(
          this.callStore.timer
            ? this.$t("alert.areYouSureToEndThisCall")
            : this.$t("alert.areYouSureToRejectThisCall"),
          {
            title: this.$t("alert.areYouSure"),
            size: "sm",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: this.callStore.timer
              ? this.$t("alert.endThisCall")
              : this.$t("alert.declineThisCall"),
            cancelTitle: this.$t("button.cancel"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.$emit("call:end", null, () => {
              this.callStore.isMinimized = false;
            });
          }
        });
    },
  },
  setup() {
    const callStore = useCallStore();

    return {
      callStore,
    };
  },
};
</script>

<style lang="scss">
.minimized-modal {
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 10001;
  position: absolute !important;
  transition: opacity 0.15s linear;
  background-color: white;
  border: none;
  box-shadow: 0 5px 20px 0 rgba(47, 47, 47, 0.1);
  border-radius: 20px !important;
  padding: 1rem 1.5rem;
}

.cursor-pointer {
  cursor: pointer;
}

.minimized-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;

  .default-avatar {
    width: 40px !important;
    height: 40px !important;
  }

  .timer {
    min-width: 50px;
  }

  .text {
    cursor: pointer;
    margin-right: 1rem;
    margin-bottom: 0 !important;
  }
}

.minimized-modal-class .modal-content {
  border-radius: 20px !important;
}

.pulse-avatar-small {
  background: black;
  border-radius: 50%;

  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: pulseSmall 2s infinite;
}

@keyframes pulseSmall {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #8d518526;
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 5px #8d518526;
  }

  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 #8d518526;
  }
}
</style>
